import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { useAuthStore } from "../../model/store/authStore";

export const logOut = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstance.post<string>(
    LIGIN_API_URL.logOut(),
    {},
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};
